import CloseIcon from '@mui/icons-material/Close';
import DownloadIcon from '@mui/icons-material/Download';
import { Box, Tooltip, Typography } from '@mui/material';
import { DocumentProps, usePDF } from '@react-pdf/renderer';
import { useState } from 'react';

import { TEXT_CONTENT } from '../../../utils/constants';
import { ErrorBoundary } from '../../error';
import { Loading } from '../../progress';
import PdfReader from './PdfReader';

export default function CustomPdfViewer({
  title = 'ANDR Shift Map 14-08-2024',
  fileName = 'ANDR_Shift_Map_14-08-2024',
  doc,
  onClose = () => {},
  isLoading = false,
}: {
  title?: string;
  fileName?: string;
  doc?: React.ReactElement<DocumentProps>;
  onClose?: () => void;
  isLoading?: boolean;
}) {
  const [instance, updateInstance] = usePDF({ document: doc });
  const [prevDoc, setPrevDoc] = useState(doc);
  if (prevDoc !== doc) {
    if (doc) updateInstance(doc);
    setPrevDoc(doc);
  }

  const downLoadPdf = () => {
    if (instance.url) {
      const a = document.createElement('a');
      a.href = instance.url || '';
      a.download = fileName || title || 'document';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        width: '100%',
        background: '#bbbbbb',
        // padding: 2,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          background: '#3a3a3a',
          padding: '1rem 1rem',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Box sx={{ flex: 1 }}>
          <Typography
            variant="h5"
            sx={{ fontSize: '1.12rem', fontWeight: 750, color: '#ffffff' }}
          >
            {title}
          </Typography>
        </Box>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            gap: 2,
          }}
        >
          {/* <Button
            title={TEXT_CONTENT.DOWNLOAD}
            // variant="outlined"
            color="info"
            onClick={downLoadPdf}
          >
            &#8681;
          </Button> */}
          {!isLoading && !instance?.loading && (
            <Tooltip title={TEXT_CONTENT.DOWNLOAD}>
              <Box
                sx={{
                  cursor: 'pointer',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  color: '#FFF',
                }}
                onClick={downLoadPdf}
              >
                <DownloadIcon fontSize="large" />
              </Box>
            </Tooltip>
          )}
          <Tooltip title={TEXT_CONTENT.CLOSE}>
            <Box
              sx={{
                cursor: 'pointer',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                color: '#FFF',
              }}
              onClick={onClose}
            >
              <CloseIcon fontSize="large" />
            </Box>
          </Tooltip>
        </Box>
      </Box>
      <Box sx={{ flex: 1, overflow: 'auto', px: 1 }}>
        {isLoading || instance?.loading ? (
          <Loading message="Fetching data..." />
        ) : (
          <ErrorBoundary msg="Oops! There was a problem loading the PDF preview. Please retry. You can also download it using the icon above.">
            <PdfReader file={instance.blob} />
          </ErrorBoundary>
        )}
      </Box>
    </Box>
  );
}
